import React from 'react';

type NoticeTone = 'error' | 'warning' | 'success' | 'neutral';

const toneClasses: Record<NoticeTone, string> = {
  error: 'border-[var(--admin-rose)] bg-[var(--admin-rose-soft)] text-[var(--admin-rose)]',
  warning: 'border-[var(--admin-amber)] bg-[var(--admin-amber-soft)] text-[var(--admin-muted)]',
  success: 'border-[var(--admin-emerald)] bg-[var(--admin-emerald-soft)] text-[var(--admin-emerald)]',
  neutral: 'border-[var(--admin-border)] bg-white/75 text-[var(--admin-muted)]',
};

interface AdminNoticeProps {
  title?: string;
  tone?: NoticeTone;
  children: React.ReactNode;
  action?: React.ReactNode;
}

export const AdminNotice: React.FC<AdminNoticeProps> = ({ title, tone = 'neutral', children, action }) => (
  <div className={`rounded-2xl border px-4 py-3 text-sm ${toneClasses[tone]}`}>
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        {title ? <p className="font-semibold">{title}</p> : null}
        <div className={title ? 'mt-1' : undefined}>{children}</div>
      </div>
      {action}
    </div>
  </div>
);

interface AdminEmptyStateProps {
  title: string;
  children: React.ReactNode;
}

export const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({ title, children }) => (
  <div className="rounded-2xl border border-dashed border-[var(--admin-border)] px-4 py-10 text-center text-sm text-[var(--admin-muted)]">
    <p className="font-semibold text-[var(--admin-text)]">{title}</p>
    <div className="mx-auto mt-2 max-w-xl">{children}</div>
  </div>
);

export const AdminSkeletonRows: React.FC<{ rows?: number }> = ({ rows = 4 }) => (
  <div className="space-y-2">
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={index}
        className="h-12 animate-pulse rounded-xl border border-[var(--admin-border)] bg-white/60"
      />
    ))}
  </div>
);
